import { View } from 'react-native'

import { styled } from '~/utils'

export const Root = styled(View, theme => {
  return {
    base: {
      flex: 1,
      maxHeight: theme.spacingStackOnepulse,
    },
    variants: {},
  }
})
